import React from 'react';

const PlayIcon = () => {
  const className = 'c-PlayIcon';

  return (
    <svg
      className={className}
      width="31"
      height="31"
      fill="none"
      viewBox="0 0 31 31"
    >
      <path
        fill="#EE1D52"
        d="M15.5 28.417c7.134 0 12.917-5.783 12.917-12.917 0-7.134-5.783-12.917-12.917-12.917-7.134 0-12.917 5.783-12.917 12.917 0 7.134 5.783 12.917 12.917 12.917z"
      ></path>
      <path fill="#fff" d="M12.917 10.333l7.75 5.167-7.75 5.167V10.333z"></path>
    </svg>
  );
};

export default PlayIcon;
